import React, { useState, useEffect, useRef } from "react";
import "flatpickr/dist/themes/dark.css";
import Flatpickr from "react-flatpickr";
import dateFormat from "dateformat";

const DateRange = ({ name, value, onChange }) => {
    const [dateRange, setDateRange] = useState([new Date(), new Date()]);

    const onChangeRef = useRef(onChange);

    useEffect(() => {
        onChangeRef.current = onChange;
    }, [onChange]);

    const today = new Date();

    // Helpers
    const cloneDate = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());

    const getMonday = (d) => {
        const date = cloneDate(d);
        const day = date.getDay();
        const diff = (day === 0 ? -6 : 1) - day;
        date.setDate(date.getDate() + diff);
        return date;
    };

    const getSunday = (monday) => {
        const date = cloneDate(monday);
        date.setDate(date.getDate() + 6);
        return date;
    };

    const currentMonday = getMonday(today);
    const currentSunday = getSunday(currentMonday);

    const lastMonday = new Date(currentMonday);
    lastMonday.setDate(lastMonday.getDate() - 7);
    const lastSunday = getSunday(lastMonday);

    const setRange = (start, end, instance) => {
        const range = [start, end];
        setDateRange(range);
        instance.setDate(range, true);
        changeDate(range);
        instance.close();
    };

    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    const changeDate = (date) => {
        if (onChangeRef.current && name && date?.length === 2) {
            const formatted =
                dateFormat(date[0], 'mmm d, yyyy') + ' to ' + dateFormat(date[1], 'mmm d, yyyy');
            onChangeRef.current(name, formatted);
        }
    };

    const ranges = {
        'Today': [cloneDate(today), cloneDate(today)],
        'Yesterday': [cloneDate(yesterday), cloneDate(yesterday)],
        'Current Week': [currentMonday, today],
        'Last Week': [lastMonday, lastSunday],
        'Last 7 Days': [new Date(today.getFullYear(), today.getMonth(), today.getDate() - 6), cloneDate(today)],
        'Current Month': [new Date(today.getFullYear(), today.getMonth(), 1), cloneDate(today)],
        'Last Month': [
            new Date(today.getFullYear(), today.getMonth() - 1, 1),
            new Date(today.getFullYear(), today.getMonth(), 0),
        ],
        'Last 30 Days': [new Date(today.getFullYear(), today.getMonth(), today.getDate() - 29), cloneDate(today)],
        'Current Year': [new Date(today.getFullYear(), 0, 1), cloneDate(today)],
        'Last Year': [
            new Date(today.getFullYear() - 1, 0, 1),
            new Date(today.getFullYear() - 1, 11, 31),
        ],
    };

    return (
        <Flatpickr
            className="form-control"
            options={{
                mode: 'range',
                dateFormat: 'M j, Y',
                maxDate: 'today',
                locale: { firstDayOfWeek: 1 },
                defaultDate: [new Date(today.getFullYear(), today.getMonth() - 1, 1)],
                onOpen: function (selectedDates, dateStr, instance) {
                    if (instance.calendarContainer.querySelector('.range-buttons')) return;

                    const container = document.createElement('div');
                    container.className = 'range-buttons';
                    container.style.display = 'flex';
                    container.style.flexWrap = 'wrap';
                    container.style.gap = '4px';
                    container.style.margin = '8px 0';

                    Object.entries(ranges).forEach(([label, [start, end]]) => {
                        const btn = document.createElement('button');
                        btn.textContent = label;
                        btn.className = 'btn btn-primary btn-sm';
                        btn.onclick = () => setRange(start, end, instance);
                        container.appendChild(btn);
                    });

                    instance.calendarContainer.appendChild(container);
                },
            }}
            placeholder="Date range"
            value={value}
            onChange={changeDate}
        />
    );
};

export default DateRange;
